import { use, useMemo } from "react";
import { StepsManagerContext } from "../contexts/StepsManager";
import { CreateMissionScreensContext } from "../contexts/CreateMissionManager";
import { MissionScreens } from "../navigations/CreateMissionStack";

type UseBubbleStepOriginParams = MissionScreens;

export const useBubbleStepOrigin = (currentStepName: UseBubbleStepOriginParams | "__DEFAULT__") => {
    const { currentStepIndex } = use(CreateMissionScreensContext);
    const { stepsX } = use(StepsManagerContext);

    const origin = useMemo<[number, number]>(() => {
        if (currentStepName === "__DEFAULT__") {
            return [stepsX[0] || 20, 0];
        }

        if (!stepsX || !currentStepIndex) {
            // used in testing where the context is not available
            // 20 is just to have a little space from the box upper left corner
            return [20, 0];
        }
        return [stepsX[currentStepIndex(currentStepName) || 0], 0];
    }, [currentStepIndex, currentStepName, stepsX]);

    return origin;
};
